export { DeviceAuthorizer } from "./DeviceAuthorizer";
export { getDeviceAuthorizerCredentials } from "@auth0/ai/Device";
